// extracted by mini-css-extract-plugin
module.exports = {"alert":"updateAlert_alert__5YR2c","alertText":"updateAlert_alert__text__djaCs","alertLoader":"updateAlert_alert__loader__3mMN1"};